import React, { Component } from 'react';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';


const progressCellRenderer = (value, rate) => {
	var html = "";
    
    html+= '<div class="progress-small">'
    html+= "    <div class='progress-title' style='text-align : center'>"+ value + "</div>"
    html+= '    <div class="progress text-center" style="">'
    html+= '        <span class="progress-value">' + rate + '%</span>'
    html+= '        <div class="progress-bar" role="progressbar" style="width: ' + rate + '%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"/>'
    html+= '    </div>'
    html+= '</div>'

	return html;
}
class BranchTop extends Component {
	constructor(props) {
		super(props);
		this.state = {
			year : this.props.year,
            tableData : null,
            topCount : 10
		}
	}


    componentWillReceiveProps = (nextProps) => {
        this.setState({
            loc_info : nextProps.loc_info
        }, () => {
            this.setState({tableData: this.listClean()}, () => {
            });
        })
    }

    // 해당 년도에 계약된 원/어린이집이 없는 경우 리스트에서 제외
	listClean = () => {
        var list = this.props.branch_infos
        var tableData = []
        if(list !== null) {
            var addCount = 0
            for(var i = 0; list.length; i++) {
                if(list[i].TYPE != 'H'){
                    addCount++
                    tableData.push({
                        RANK: addCount,
                        NAME: list[i].NAME,
                        RATE_SHARE: list[i].contract[this.props.year].RATE_SHARE,
                        TOTAL: list[i].contract[this.props.year].TOTAL,
                    })
                }
                if(addCount >= this.state.topCount) {
                    break
                }
            }
        }
		return tableData;
	}

    onGridReady = params => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    }

    onFirstDataRendered = params => {
        params.api.sizeColumnsToFit();
        this.setFirstRowdata()
    }

    defaultColDef = {
        resizable : false,
        editable: false,
        headerClass:'bg-dark text-light',
        suppressMovable: true
    };
    listColumn = [
        {
            headerName: "순위",
            field : "RANK",
            minWidth : 50,
            resizable : false,
            cellClass: function(param) {return "text-center"},
            cellRenderer: (param) => {
                return param.value
            }
        },
        {
            headerName: "지사",
            field: "NAME",
            sortable: true,
            minWidth: 130,
            cellRenderer: (param) => {
                return param.value
            }
        },
        {
            headerName: "전체 계약 점유율",
            field: "RATE_SHARE",
            sortable: true,
            cellClass: "text-center",
            cellRenderer: (param) => {
                return param.value
            }
        },
    ];

    setFirstRowdata = () => {
        if(this.props.branch !== null) {
            var rows = []
            rows.push({
                RANK: this.props.branch.contract[this.props.year].RANK,
                NAME: this.props.branch.NAME,
                RATE_SHARE: this.props.branch.contract[this.props.year].RATE_SHARE
            })
    
            this.gridApi.setPinnedTopRowData(rows)
        }
    }

    render() {

        return (
            <div className="card border-top border-3 border-top-secondary" style={{ height: (this.props.height) + "px" }}>
                <div className="card-header d-flex" style={{padding:"0.3rem 1.25rem"}}>
                    <h5 className="card-header-title">
                        TOP {this.state.topCount} 지사
                    </h5>
                </div>
                <div className="card-body" style={{ padding: "0px", textAlign: "center", overflow: "auto" }}>
                    {(this.state.tableData === null || this.props.branch === null) ? (
                        <span className="dashboard-spinner spinner-xxl" style={{ marginTop: "30px" }}></span>
                    ) : ((this.state.loc_info !== null && (this.state.tableData === null || this.state.tableData.length < 1)) ? (
                        <div className="text-center align-middle" style={{ width: "100%", height: "100%", padding: "70px 0" }}>No data</div>
                    ) : (
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ag-theme-balham" style={{ height: (this.props.height - 44) + "px", padding: "0px" }}>
                                <AgGridReact
                                    columnDefs={this.listColumn}
                                    defaultColDef={this.defaultColDef}
                                    rowData={this.state.tableData}
                                    rowHeight={40}
                                    rowSelection="single"
                                    onGridReady={this.onGridReady}
                                    onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                                    getRowStyle={function(params) {
                                            if (params.node.rowPinned) {
                                                return { 'font-weight': 'bold', 'color': '#f5a27b' };
                                            }
                                        }
                                    }
                                >
                                </AgGridReact>
                            </div>
                        )
                        )}
                </div>
            </div>
        )

    }

}


export default BranchTop;